<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <ul>
                        <li @click="scrollToElement('vn-1')">Cách vào màn hình [Thông tin học viên]</li>
                        <li @click="scrollToElement('vn-2')">Tìm kiếm học viên</li>
                        <li @click="scrollToElement('vn-3')">Xuất thành tích học viên</li>
                        <li @click="scrollToElement('vn-4')">Danh sách khóa học</li>
                    </ul>
                </div>
                <div id="vn-1">
                    <h1>1.Cách vào màn hình [Thông tin học viên]</h1>
                </div>
                <div><img src="/static\images\vi\newManual\manageStudentManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào [Avatar] hoặc [Tên người dùng] để mở menu quản lý dành cho giáo viên.</p>
                    <p>② Khi nhấn vào mục [Thông tin học viên ] thì sẽ chuyển đến màn hình [Thông tin học viên] của các học viên tham gia khóa học mà giáo viên phụ trách</p>
                </div>
                <div id="vn-2">
                    <h1>2.Tìm kiếm học viên</h1>
                </div>
                <div>
                    <p>
                        <b><i>2.1 Tìm kiếm theo tên học viên</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageStudentManual-2.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào tab [Tên học viên]</p>
                    <p>② Nhập tên học viên muốn tìm kiếm</p>
                </div>
                <div>
                    <p>
                        <b><i>2.2 Tìm kiếm theo email</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageStudentManual-3.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào tab [Email]</p>
                    <p>② Nhập Email học viên muốn tìm kiếm</p>
                </div>
                <div id="vn-3">
                    <h1>3.Xuất thành tích học viên</h1>
                </div>
                <div><img src="/static\images\vi\newManual\manageStudentManual-4.png" alt="" /></div>
                <div>
                    <p>Nhấn vào nút [Xuất thành tích học viên] để xuất file excel thành tích của học viên</p>
                </div>
                <div id="vn-4">
                    <h1>4.Danh sách khóa học</h1>
                </div>
                <div>
                    <p>
                        <b><i>4.1 Tìm kiếm khóa học</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageStudentManual-5.png" alt="" /></div>
                <div>
                    <p>① Nhập tiêu đề muốn tìm kiếm vào khung tìm kiếm</p>
                    <p>② Nhấn vào phân loại khóa học muốn tìm kiếm</p>
                    <p>③ Nhấn vào các nút để hiển thị hoặc không hiển thị các khóa học ứng với trạng thái</p>
                </div>
                <div>
                    <p>
                        <b><i>4.2 Chi tiết khóa học</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageStudentManual-6.png" alt="" /></div>
                <div>
                    <p>Nhấn vào khóa học cần xem nội dung chi tiết</p>
                </div>
                <div>
                    <p>
                        <b><i>4.3 Danh sách câu trả lời sai bài tập nhỏ</i></b>
                    </p>
                </div>
                <div><img src="/static\images\vi\newManual\manageStudentManual-7.png" alt="" /></div>
                <div>
                    <p>Nhấn vào tỉ lệ điểm để xem danh sách câu sai bài tập nhỏ của học viên</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/en/manageStudent_manual.vue